import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { withStyles, MuiThemeProvider, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import { Typography, Grid } from '@material-ui/core';

import { AppState, Actions, store, IPageState } from '../../appredux'
import CONFIG from '../../cfg/config';
import { MenuService, AsortMenuWiersz, AsortGrupyWiersz, Font, AsortWWWMenuNagl } from '../../api';

import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import { TableRow } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import SearchIcon from '@mui/icons-material/Search';

import CircularProgress from '@material-ui/core/CircularProgress';
import { IconButton } from '@material-ui/core';
import AppsIcon from '@mui/icons-material/Apps';
import MenuIcon from '@mui/icons-material/Menu';

import { AddItem } from '../PanelRightBasket';
import DialogChangeItem from '../dialog/ChangeItem';
import themeDialog from '../../themes-dialog';
import { fontSelect } from '../../fonts';
import { hexToRgb, sendErrorLog } from '../common/helpers';
import KartaDanie from './KartaDanie';

//PM 2021-03-11
//wstrzykniecie tylko uzywanych pol z magazynu danych
type ZamowienieProps = {
  page: IPageState,
  windowWidth: number,
}

type ZamowienieState = {
  headerIds: number[],
  headers: (AsortMenuWiersz & { kolor?: boolean })[],
  openChange: boolean,
  item: AsortGrupyWiersz,
  reload: number,

  viewMain: number,
  asort: AsortGrupyWiersz[],
  view: number,
  asortMax: number,
  scroll: boolean
}

class Zamowienie extends React.Component<ZamowienieProps & WithStyles<typeof styles>, ZamowienieState> {
  textTheme = fontSelect(this.props.page.fonts, 7, 1) as React.CSSProperties;
  contentTheme = fontSelect(this.props.page.fonts, 8, 2) as React.CSSProperties;

  constructor(props: ZamowienieProps & WithStyles<typeof styles>) {
    super(props, {});
    //this.getData();
    this.state = {
      headerIds: [],
      headers: [],
      openChange: false,
      item: new AsortGrupyWiersz(),
      reload: 0,

      viewMain: 0,
      asort: [],
      view: 2,
      asortMax: 10,
      scroll: true
    };
  }

  componentDidMount() {
    this.getData();
  }

  //PM 2021-03-11
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  componentDidUpdate(prevProps: ZamowienieProps, prevState: ZamowienieState) {
    if (prevProps.page.menuItems !== this.props.page.menuItems) {
      this.getData();
    }
    //if (prevProps.page.selectedMenuItem !== this.props.page.selectedMenuItem) {
    if (prevProps.page.refresh !== this.props.page.refresh) {
      this.getData();
      this.setState({viewMain: 0})
    }

  }

  setView = (view: number) => {
    if(this.state.view !== view) this.setState({view: view})
  }

  setScroll = () => {
    this.setState({scroll: false})
  }

  setAsortMax = (n: number) => {
    if(this.state.asortMax !== n) this.setState({asortMax: n})
  }

  setItem = (item: AsortGrupyWiersz) => {
    if(this.state.item.asort_id !== item.asort_id) this.setState({item: item})
  }

  //PM 2021-11-03
  //if (this.props.asort[i] && this.props.asort[i][0] && this.props.asort[i][0].grupa_id && this.props.asort[i][0].grupa_id === e)
  //await
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  getData = () => {
    let id = this.props.page.selectedMenuItem;
    let data = this.props.page.asortHeaders.filter((e) => e.menu_id === id)
    let ids: number[] = [];
    data.forEach((e) => { ids.push(e.grupa_id) });
    this.setState({ headerIds: ids, headers: data });

    let load = true;
    ids.forEach(async (e) => {
      load = true;
      for (let i = 0; i < this.props.page.asort.length; i++) {
        if (this.props.page.asort[i] && this.props.page.asort[i][0] && this.props.page.asort[i][0].grupa_id && this.props.page.asort[i][0].grupa_id === e) {
          load = false;
          break;
        }
      }
      if (load) {
        await this.getAsortData(e)
      }
    });
  };

  //PM 2021-09-01
  //console.error -> console.log()
  async getAsortData(id: number) {
    try {
      const res = await MenuService.getAsort({ hotelId: CONFIG.hotelID, aOperatorId: Number(sessionStorage.getItem("operator_id")), aGrupaId: id }, {})
      //console.log(res.result)
      await store.dispatch(Actions.pageState.getAsort(res.result));
    } catch (err) {
      console.log(err)
      await sendErrorLog("0", "-1", '/manager/dajAsortWwwGrupyWiersz')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/dajAsortWwwGrupyWiersz", 2))
    }
  }

  //PM 2021-03-11
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  addItemFunc = async (row: AsortGrupyWiersz) => {
    //console.log(row)
    //console.log(this.state)
    //console.log(this.props)
    this.setState({ item: row, viewMain: 1, scroll: true })
    this.getDataAsort(row)
    // if (row.nazwa_do_zm === 1) {
    //   this.setState({ openChange: true, item: row })
    // } else {
    //   const menuItem = this.props.page.menuItems.find(e => e.menu_id === this.props.page.selectedMenuItem)

    //   if (menuItem)
    //     if (this.props.page.minItems < menuItem.zamowienie_min_ilosc_pozycji) {
    //       await store.dispatch(Actions.pageState.setMinItems(menuItem.zamowienie_min_ilosc_pozycji));
    //     }

    //   await AddItem(row);
    // }
  }

  getDataAsort = (item: AsortGrupyWiersz) => {
    //let id = this.props.page.selectedMenuItem;
    this.setState({asort: []})
    let id = item.grupa_id
   
    MenuService.getAsortFoto({ hotelId: CONFIG.hotelID, aOperatorId: Number(sessionStorage.getItem("operator_id")), aGrupaId: id }, {})
    .then(
      (res : any) => {
        //console.log(res.result)
        //store.dispatch(Actions.pageState.getAsort(res.result));
        this.setState({asort: res.result})
        }
      )        
    .catch( (err : any) => {
      console.error
      } 
    );

  };


  

  closeDialogChangeItem = () => {
    this.setState({ openChange: false })
  }

  //PM 2021-03-17
  checkUndefined = (asort: AsortGrupyWiersz[][]) => {
    if (asort.length <= 0) return false;

    let value = true;

    asort.forEach(x => {
      if (x == undefined) {
        value = false;
      }
    });

    return value;
  }

  //PM 2021-03-11
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  render() {
    const classes = this.props.classes;
    const header = this.state.headers;
    let data: AsortGrupyWiersz[][] = [];
    let asort: AsortGrupyWiersz[][] = [];
    let half = header.length % 2 === 0 ? header.length / 2 : header.length / 2 + 1;
    let lengthAll = 0;
    let lengthHalf = 0;
    let kolor = true;

    let c1 = "rgb(36, 36, 36)"
    let c2 = "rgb(36, 36, 36)"

    let contentColorRgb = hexToRgb(this.contentTheme.color as string)
    if(!contentColorRgb){
      contentColorRgb = {r: 36, g:36, b:36}
    } 
    c1 = `rgba(${contentColorRgb.r}, ${contentColorRgb.g}, ${contentColorRgb.b}, 1)`
    c2 = `rgba(${contentColorRgb.r}, ${contentColorRgb.g}, ${contentColorRgb.b}, 0.65)`
   


    header.forEach(e => {
      data = this.props.page.asort.filter(el => el[0] && el[0].grupa_id === e.grupa_id);
      //if(data && data[0] && data[0].length > 0){asort.push(data[0].slice(0, 3));}
      //else {asort.push(data[0]);}
      
      asort.push(data[0]);
      //vscTest
      //console.log(e.grupa_opis, data)
    })

    header.forEach((e) => {
      kolor = true;
      this.props.page.basket.forEach((b) => {
        if (Number(b.grupa_id) === e.grupa_id)
          kolor = false;
      })
      e.kolor = kolor;
    })

    //vscTest
    //console.log(asort)

    if (this.checkUndefined(asort) && header.length % 2 === 1) {
      lengthAll = asort.flat().length

      for (let i = 0; i < asort.length / 2 - 1; i++) {
        lengthHalf += asort[i].length
      }
      if (lengthHalf * 2 >= lengthAll) {
        half = header.length / 2
      }
    }

    const header1 = header.slice(0, half);
    const header2 = header.slice(half);
    const allAsort1 = asort.slice(0, half);
    const allAsort2 = asort.slice(half);

    let asort1 = allAsort1.map(x => x ? x.slice(0, this.state.asortMax): [])
    let asort2 = allAsort2.map(x => x ? x.slice(0, this.state.asortMax): [])

    //////////////////////////////////////////////////////

    // let headerAsort = this.state.headers; 
    //   let dataAsort: any = [] 
    //   let asortAsort: any = []
    //   headerAsort.forEach((e: any) => {
    //     //dataAsort = this.props.page.asort.filter((el: any) => el[0].grupa_id == e.grupa_id);   
    //     dataAsort = this.state.asort.filter((el: any) => el.grupa_id == e.grupa_id);   
    //     asortAsort.push(dataAsort);
    //   });

      let asortAsort = this.state.asort

    let selectedStyle = {color: this.textTheme.color, fontSize: this.textTheme.fontSize, fontWeight: "bold"} as React.CSSProperties;
    let notSelectedStyle = { fontSize: this.textTheme.fontSize} as React.CSSProperties;
    //backgroundColor: "rgba(0, 0, 0, 0.04)",

    return (
      <>
        {this.state.viewMain === 0 ?
        <>
         <div style={{ width: "100%", textAlign: "end", margin: "-20px 0px 10px 0px" }}>
            <IconButton
              className={classes.textButton}
              onClick={() => this.setAsortMax(5)}
              style={this.state.asortMax === 5 ? selectedStyle : notSelectedStyle}
            >
              5
            </IconButton>
            <IconButton
              className={classes.textButton}
              onClick={() => this.setAsortMax(10)}
              style={this.state.asortMax === 10 ? selectedStyle : notSelectedStyle}
            >
              10
            </IconButton>
            <IconButton
              className={classes.textButton}
              onClick={() => this.setAsortMax(15)}
              style={this.state.asortMax === 15 ? selectedStyle : notSelectedStyle}
            >
              15
            </IconButton>
           
          </div>

        <Grid item xs={12} md={6} style={{ paddingRight: this.props.windowWidth > 600 ? "20px" : "0px", marginTop: "-1.2em" }}>
          {asort1.length && asort1[0] !== undefined ? header1.map((tab, index) => (
            <React.Fragment key={tab.grupa_id}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ ...this.textTheme, cursor: "pointer", paddingBottom: asort1[index] && asort1[index][0] && asort1[index][0].asort_nazwa.includes("|") ? "10px" : "5px" }}
                    onClick={async () => { await this.addItemFunc({...allAsort1[index][0], asort_id: -1} ) }} >{tab.grupa_opis}</TableCell>
                    <TableCell></TableCell>
                    {/* <TableCell></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {asort1[index] ? asort1[index].map((row, index1) => (
                    <TableRow key={tab.grupa_opis + row.asort_nazwa}>
                      <TableCell onClick={async () => { await this.addItemFunc(row) }} className={classes.cell} style={{ ...this.contentTheme, cursor: "pointer", paddingBottom: row.asort_nazwa.includes("|") ? "5px" : "inherit", fontWeight:  "normal", color: c1 }} align="left"> {/*Math.floor(index1  / 5) % 2  === 0 ? "bold" :*/}{/*color: Math.floor(index1  / 5) % 2  === 0 ? c1 : c2*/}
                        {row.asort_nazwa.includes("|") ?
                          <Fragment> <span>{row.asort_nazwa.split("|")[0]}</span><br /><span style={{ fontWeight: "normal", paddingBottom: "5px" }}>{row.asort_nazwa.split("|")[1]}</span>  </Fragment>
                          : row.asort_nazwa}
                      </TableCell>
                      <TableCell className={classes.cell} style={{ ...this.contentTheme, fontWeight: "normal", color: c1 }} align="right">{row.cena}</TableCell>
                      {/* <TableCell align="right" style={{ width: "25px" }}>
                        <Button className={classes.add} classes={{ "label": this.props.windowWidth > 600 ? classes.label : classes.labelPhone }}
                          onClick={async () => { await this.addItemFunc(row) }}><span style={{ fontSize: "16px", fontWeight: "normal" }}>...</span></Button>
                      </TableCell> */}
                    </TableRow>
                  )) : null}
                          {asort1 && asort1[index] && asort1[index].length > 0 ?
                              <TableRow key={"99"}>
                                  <TableCell onClick={async () => { await this.addItemFunc({...allAsort1[index][0], asort_id: -1} ) }}  className={classes.cell} style={{ ...this.contentTheme, cursor: "pointer", paddingBottom: "inherit", fontWeight: "bold", color: this.textTheme.color }} align="left">
                                      {`zobacz zdjęcia i opisy wszystkich ${allAsort1[index].length} ...`}
                                  </TableCell>
                              </TableRow>
                              : null}

                </TableBody>
              </Table>
              <hr className={classes.hr} />
            </React.Fragment>
          ))
            :
            (
              <Typography variant="h6" component="h2" color="primary" style={{ padding: "20px", fontSize: "14px" }}>
                <b>Ładowanie...</b>
              </Typography>
            )}
        </Grid>
        <Grid item xs={12} md={6} style={{ paddingRight: this.props.windowWidth > 600 ? "20px" : "0px", marginTop: "-1.2em" }}>
          {asort2.length ? header2.map((tab, index) => (
            <React.Fragment key={tab.grupa_id}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.head} style={{ ...this.textTheme, cursor: "pointer", paddingBottom: asort2[index] && asort2[index][0] && asort2[index][0].asort_nazwa.includes("|") ? "10px" : "5px" }}
                    onClick={async () => { await this.addItemFunc({...allAsort2[index][0], asort_id: -1}) }}>{tab.grupa_opis}</TableCell>
                    <TableCell></TableCell>
                    {/* <TableCell></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {asort2[index] ? asort2[index].map((row, index1) => (
                    <TableRow key={tab.grupa_opis + row.asort_nazwa}>
                      <TableCell onClick={async () => { await this.addItemFunc(row) }} className={classes.cell} style={{ ...this.contentTheme, cursor: "pointer", paddingBottom: row.asort_nazwa.includes("|") ? "5px" : "inherit",fontWeight: "normal", color: c1 }} align="left"> {/*Math.floor(index1  / 5) % 2  === 0 ? "bold" :*/}{/*color: Math.floor(index1  / 5) % 2  === 0 ? c1 : c2*/}
                        {row.asort_nazwa.includes("|") ?
                          <Fragment> <span>{row.asort_nazwa.split("|")[0]}</span><br /><span style={{ fontWeight: "normal", paddingBottom: "5px" }}>{row.asort_nazwa.split("|")[1]}</span>  </Fragment>
                          : row.asort_nazwa}
                      </TableCell>
                      <TableCell className={classes.cell} style={{ ...this.contentTheme, fontWeight: "normal", color: c1 }} align="right">{row.cena}</TableCell>
                      {/* <TableCell align="right" style={{ width: "25px" }}>
                        <Button className={classes.add} classes={{ "label": this.props.windowWidth > 600 ? classes.label : classes.labelPhone }}
                          onClick={async () => { await this.addItemFunc(row) }}><span style={{ fontSize: "16px", fontWeight: "normal" }}>...</span></Button>
                      </TableCell> */}
                    </TableRow>
                  )) : null}
                    {asort2 && asort2[index] && asort2[index].length > 0 ?
                              <TableRow key={"99"}>
                                  <TableCell onClick={async () => { await this.addItemFunc({...allAsort2[index][0], asort_id: -1}) }} className={classes.cell} style={{ ...this.contentTheme, cursor: "pointer", paddingBottom: "inherit", fontWeight: "bold", color: this.textTheme.color, }} align="left">
                                      {`zobacz zdjęcia i opisy wszystkich ${allAsort2[index].length} ...`}
                                  </TableCell>
                              </TableRow>
                              : null}
                </TableBody>
              </Table>
              <hr className={classes.hr} />
            </React.Fragment>
          ))
            : null}
        </Grid>
        {this.state.openChange ?
          <MuiThemeProvider theme={themeDialog}>
            <DialogChangeItem item={this.state.item} open={this.state.openChange} close={this.closeDialogChangeItem} />
          </MuiThemeProvider> : null}
      </> : //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      <>
       <Fragment>
          <div style={{ width: "100%", textAlign: "end", margin: "-20px 0px 5px 0px", paddingBottom: "0px" }}>
                {/* <IconButton
                  className={classes.iconButton}
                  onClick={() => this.setView(0)}
                >
                  <MenuIcon className={classes.icon} />
                </IconButton> */}
                <IconButton
                  className={classes.textButton}
                  onClick={() => this.setView(1)}
                  style={this.state.view === 1 ? selectedStyle : notSelectedStyle}
                >
                  1
                </IconButton>
                <IconButton
                  className={classes.textButton}
                  onClick={() => this.setView(2)}
                  style={this.state.view === 2 ? selectedStyle : notSelectedStyle}
                >
                  2
                </IconButton>
                <IconButton
                  className={classes.textButton}
                  onClick={() => this.setView(3)}
                  style={this.state.view === 3 ? selectedStyle : notSelectedStyle}
                >
                  3
                </IconButton>
          </div>

          {this.state.view === 1 && asortAsort? asortAsort.map((danie1: AsortGrupyWiersz, index: number) => (
            <KartaDanie 
              danie = { danie1 }
              key={ danie1.asort_id }
              view={this.state.view}
              //lang={this.props.page.lang}
              ostatni={asortAsort && asortAsort.length === index +1}
              selected={this.state.item.asort_id === danie1.asort_id}
              setItem={this.setItem}
              scroll={this.state.scroll}
              setScroll={this.setScroll}
            />
          )) : (this.state.view === 2 || this.state.view === 3) && asortAsort[0]?
           <Grid container spacing={4}>
            {asortAsort.map((danie1: AsortGrupyWiersz, index: number) => (
            <KartaDanie 
              danie = { danie1 }
              key={ danie1.asort_id }
              view={this.state.view}
              //lang={this.props.page.lang}
              ostatni={asortAsort && asortAsort.length === index +1} 
              selected={this.state.item.asort_id === danie1.asort_id}
              setItem={this.setItem}
              scroll={this.state.scroll}
              setScroll={this.setScroll}
            />
            )) }
         </Grid> : <div style={{width: "100%", textAlign: "center"}}><CircularProgress className={classes.progress}/></div> }
          
         

        </Fragment>
      </>}    
      </>
    )
  }
}

const styles = (theme: Theme) => ({
  cell: {
    padding: "2px 10px 3px 2px",
  },
  add: {
    padding: "0",
    minWidth: "25px",
    width: "25px",
    height: "25.6px",
    //border: "1px solid #aaa",
    //borderRadius: "0"
    "&:hover": {
      background: "transparent"
    }
  },
  hr: {
    border: "0",
    borderBottom: "1px solid #ddd",
  },
  table: {
    marginTop: "1.2em",
    marginBottom: "1.2em"
  },
  label: {
    marginTop: "-4px"
  },
  labelPhone: {
    marginTop: "0px"
  },
  head: {
    paddingBottom: "5px"
  },
  progress: { 
    margin: theme.spacing(2) 
  },
  iconButton: {
    padding: "4px"
  },
  icon: {
    width: "0.6em !important",
    height: "0.6em !important",
  },
  textButton: {
    fontSize: "11px",
    width: "0.4em !important",
    height: "0.6em !important",
  },
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(Zamowienie));